<template>
	<div>
		<v-dialog v-model="dialog_item_groups" no-click-animation persistent scrollable content-class="full-height" lazy>
        	<v-card>
        		<v-subheader full-width>{{productName}}
        		</v-subheader>
        		<v-divider></v-divider>
        	  	<v-card-text full-height>
        	  		<!-- <v-data-table
					    :headers="headers"
					    :items="tpGroups"
					    class="elevation-0"
					    hide-actions>
					    <template slot="items" slot-scope="props">
					    	<tr @click="fn_appendItemGroup(props.item.mrp)">
					    		<td>&#8377;{{ props.item.mrp }}</td>
							    <td class="text-xs-right">
							    	<span v-for="(vItem, index) in props.item.variants" :key="index">{{vItem.unitName}} 					{{vItem.qty ? vItem.qty : 0}}{{props.item.variants.length-1 != index ? ', ' : ''}}
							    	</span>
							    </td>
					    	</tr>
					      
					    </template>
					</v-data-table> -->

					<v-layout row wrap style="padding-bottom:16px;">
						<v-flex xs4 sm4 md4><strong>MRP</strong></v-flex>
						<v-flex xs5 sm5 md5><strong>Stock</strong></v-flex>
						<v-flex xs3 sm3 md3 right-align><strong>QTY</strong></v-flex>
					</v-layout>

					<v-layout row wrap v-for="(item, index) in tpGroups" :key="index" style="align-items:baseline">
						<v-flex xs4 sm4 md4>&#8377; {{$root.numberToLocale(item.mrp)}}</v-flex>
						<v-flex xs5 sm5 md5>
							<span v-for="(unit, uIndex) in item.variants" :key="uIndex">
								{{unit.unitName}} {{unit.qty ? unit.qty : 0}}<!-- {{item.variants.length-1 != index ? ', ' : ''}} -->
							</span>
						</v-flex>
						<v-flex xs3 sm3 md3>
							<v-text-field
								style="margin-top:0"
								align-input-text-right
							  	label=""
							  	type="number"
							  	v-model.number="item.qty">
							</v-text-field>
							<!-- v-validate="'numeric|max:8'" 
			               		data-vv-name="qty" 
			               		data-vv-as="quantity"
			               		:error-messages="errors.collect('fields.'+item.unitName+vIndex)" -->
						</v-flex>
					</v-layout>
        	  			
        	  	</v-card-text>
        	  	<v-divider></v-divider>
		        <v-card-actions>
		          <v-spacer></v-spacer>
		          <v-btn color="blue darken-1" flat @click.native="$parent.fn_closeDialog()">close</v-btn>
		          <v-btn color="blue darken-1" flat @click.native="fn_appendItemGroup">Done</v-btn>
		        </v-card-actions>
	        	</v-card>	

      	</v-dialog>
	</div>
</template>	 	

<script>
export default{
	props:['tpGroups', 'productName'],
	data(){	
		return{
			dialog_item_groups: false,
			// headers: [
	  //         { text: 'MRP', sortable: false, value: 'MRP', align: 'left' },
	  //         { text: 'Stock', sortable: false, value: 'Stock', align: 'right' },
	  //       ]
		}
	},
	methods:{
		openDialogWeb: function () {	
			this.dialog_item_groups = true;
			for(let i=0; i<this.$parent.Form.productData.items.length; i++){
				let product = this.$parent.Form.productData.items[i];
				for(let j=0; j<this.tpGroups.length; j++){
					if(product.mrp == this.tpGroups[j].mrp){
						this.tpGroups[j].qty = null;
						this.tpGroups[j].qty = product.productVariants[0].qty;
						this.$forceUpdate();
						break;
					}
				}
			}
		},
		closeDialogWeb: function () {
			this.dialog_item_groups = false;
		},
		fn_appendItemGroup: function(){
			// this.$parent.Form.productDataModel.mrp = mrp;
			this.showLoading('Please wait...');
			this.$parent.fn_closeDialog();
			this.$parent.Form.productData.items = [];
			for(let i=0; i<this.tpGroups.length; i++){
				if(this.tpGroups[i].qty){
					this.$parent.Form.productDataModel.mrp = this.tpGroups[i].mrp;
					this.$parent.Form.productDataModel.productVariants[0].qty = this.tpGroups[i].qty;
					this.$parent.Form.productData.items.push(JSON.parse(JSON.stringify(this.$parent.Form.productDataModel)));
				}
			}
			this.hideLoading();
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/sale/dialogs/dialog_item_groups.vue